export const routes = [
    {
        path: '/',
        redirect: "/login",
        meta: {
            show: false, //判断是否展示菜单栏
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login'),
        meta: {
            title: "登录",
            show: false,
        },
    },
    {
        path: '/order',
        name: 'order',
        component: () => import('@/pages/common'),
        meta: {
            title: "订单管理",
            icon: "el-icon-tickets",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'order-list',
                component: () => import('@/pages/order/list'),
                meta: {
                    title: "订单列表",
                    show: true,
                },
            },
            {
                path: 'add',
                name: 'order-add',
                component: () => import('@/pages/order/add'),
                meta: {
                    title: "新增订单",
                    show: false,
                },
            },
            {
                path: 'edit',
                name: 'order-edit',
                component: () => import('@/pages/order/edit'),
                meta: {
                    title: "修改订单",
                    show: false,
                },
            },
            {
                path: 'auditing',
                name: 'order-auditing',
                component: () => import('@/pages/order/auditing'),
                meta: {
                    title: "订单审核",
                    show: false,
                },
            },
            {
                path: 'details',
                name: 'order-details',
                component: () => import('@/pages/order/details'),
                meta: {
                    title: "订单详情",
                    show: false,
                },
            },
            {
                path: 'import',
                name: 'order-import',
                component: () => import('@/pages/order/custom-import'),
                meta: {
                    title: "批量导入",
                    show: false,
                },
            },
            {
                path: 'report',
                name: 'order-report',
                component: () => import('@/pages/order/report'),
                meta: {
                    title: "报表汇总",
                    show: true,
                },
            },
            {
                path: 'report/add',
                name: 'order-report-add',
                component: () => import('@/pages/order/report-add'),
                meta: {
                    title: "报表上传",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/car',
        name: 'car',
        component: () => import('@/pages/common'),
        meta: {
            title: "车管所政策",
            icon: "el-icon-document",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'car-list',
                component: () => import('@/pages/car/list'),
                meta: {
                    title: "车管所备案查询",
                    show: true,
                },
            },
            {
                path: 'add',
                name: 'car-add',
                component: () => import('@/pages/car/list/add'),
                meta: {
                    title: "车管所备案模版上传",
                    show: false,
                },
            },
            {
                path: 'material',
                name: 'car-material',
                component: () => import('@/pages/car/material'),
                meta: {
                    title: "业务材料清单",
                    show: true,
                },
            },
            {
                path: 'material/add',
                name: 'car-material-add',
                component: () => import('@/pages/car/material/add'),
                meta: {
                    title: "业务材料清单模版上传",
                    show: false,
                },
            },
        ]
    },
    {
        path: '/document',
        name: 'document',
        component: () => import('@/pages/common'),
        meta: {
            title: "证件管理",
            icon: "el-icon-wallet",
            show: true,
        },
        children: [
            {
                path: 'list',
                name: 'document-list',
                component: () => import('@/pages/document/list'),
                meta: {
                    title: "证件列表",
                    show: true,
                },
            },
            {
                path: 'add',
                name: 'document-add',
                component: () => import('@/pages/document/add'),
                meta: {
                    title: "上传营业执照",
                    show: false,
                },
            },
            {
                path: 'details',
                name: 'document-details',
                component: () => import('@/pages/document/details'),
                meta: {
                    title: "证件详情",
                    show: false,
                },
            },
            {
                path: 'dispatch',
                name: 'document-dispatch',
                component: () => import('@/pages/document/dispatch'),
                meta: {
                    title: "新增调度",
                    show: false,
                },
            },
            {
                path: 'stocktaking',
                name: 'document-stocktaking',
                component: () => import('@/pages/document/stocktaking'),
                meta: {
                    title: "证件盘点",
                    show: false,
                },
            }
        ]
    },
    {
        path: '/system',
        name: 'system',
        component: () => import('@/pages/common'),
        meta: {
            title: "系统管理",
            icon: "el-icon-s-custom",
            show: true,
        },
        children: [
            {
                path: 'institution',
                name: 'system-institution',
                component: () => import('@/pages/system/institution/list'),
                meta: {
                    title: "甲方机构",
                    show: true,
                },
            },
            {
                path: 'institution/add',
                name: 'system-institution-add',
                component: () => import('@/pages/system/institution/list/add'),
                meta: {
                    title: "添加机构",
                    show: false,
                },
            },
            {
                path: 'institution/edit',
                name: 'system-institution-edit',
                component: () => import('@/pages/system/institution/list/edit'),
                meta: {
                    title: "修改机构",
                    show: false,
                },
            },
            {
                path: 'institution/details',
                name: 'system-institution-details',
                component: () => import('@/pages/system/institution/details'),
                meta: {
                    title: "机构详情",
                    show: false,
                },
            },
            {
                path: 'institution/account/add',
                name: 'system-institution-details-account-add',
                component: () => import('@/pages/system/institution/details/add'),
                meta: {
                    title: "添加账号",
                    show: false,
                },
            },
            {
                path: 'institution/account/edit',
                name: 'system-institution-details-account-edit',
                component: () => import('@/pages/system/institution/details/edit'),
                meta: {
                    title: "修改账号",
                    show: false,
                },
            },
            {
                path: 'user',
                name: 'system-user',
                component: () => import('@/pages/system/user'),
                meta: {
                    title: "内部车务机构",
                    show: true,
                },
            },
            {
                path: 'user/add',
                name: 'system-user-add',
                component: () => import('@/pages/system/user/add'),
                meta: {
                    title: "添加账号",
                    show: false,
                },
            },
            {
                path: 'user/edit',
                name: 'system-user-edit',
                component: () => import('@/pages/system/user/edit'),
                meta: {
                    title: "修改账号",
                    show: false,
                },
            },
            {
                path: 'region',
                name: 'system-region',
                component: () => import('@/pages/system/region'),
                meta: {
                    title: "区域维护",
                    show: true,
                },
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/router.config.js